var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg1Character(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 416,
    viewBox: "0 0 425 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.947 414.477C190.947 414.477 268.048 426.857 328.548 372.662C389.047 318.467 405.669 230.358 421.016 159.396C436.365 88.4342 403.742 25.3317 343.462 5.10313C283.181 -15.1254 257.113 36.3223 182.764 52.5801C108.414 68.838 85.7912 61.7314 33.5357 116.47C-18.718 171.21 -6.67663 274.997 59.5328 341.008C125.743 407.019 190.947 414.477 190.947 414.477Z",
    fill: "#C6FF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M190.947 414.477C190.947 414.477 268.048 426.857 328.548 372.662C389.047 318.467 405.669 230.358 421.016 159.396C436.365 88.4342 403.742 25.3317 343.462 5.10313C283.181 -15.1254 257.113 36.3223 182.764 52.5801C108.414 68.838 85.7912 61.7314 33.5357 116.47C-18.7179 171.21 -6.67663 274.997 59.5328 341.008C125.743 407.019 190.947 414.477 190.947 414.477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1Character);
export default __webpack_public_path__ + "static/media/bg1Character.db8f5bd207e89be6f77e2938f4efaa17.svg";
export { ForwardRef as ReactComponent };